export const apiUrl = process.env.REACT_APP_TS_API_URL;
export const starbookApi = process.env.REACT_APP_STARBOOK_API_URL || '/api';

const starbookBaseUrl = starbookApi.endsWith('/api') ? starbookApi.slice(0, -4) : starbookApi;

export const massageHubUrl = `${starbookBaseUrl}/hubs/massage`;
export const MASSEUR_TOKEN_PARAM = 'masseurToken';

export const requestConfig = {
  withCredentials: true,
  credentials: 'same-origin',
  headers: {
    'Content-Type': 'application/json',
  },
};
